var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLocation = function SvgLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Component 48 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 63"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Location_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1121",
    fill: "#0491a0",
    d: "M0 0h45v63H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1242",
    clipPath: "url(#Location_svg__a)",
    fill: "#0491a0"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1511",
    d: "m37.5 40.905 4.814-7.083.039-.07a19.982 19.982 0 0 0 2.621-8.708A25.593 25.593 0 0 0 38.118 6.99 20.863 20.863 0 0 0 23.057.005 21.345 21.345 0 0 0 6.986 6.9C2.24 11.886-.417 18.854.054 25.081a20.512 20.512 0 0 0 4.635 11.258l15.92 22.57H4.161a2.045 2.045 0 1 0 0 4.09h37.184a2.045 2.045 0 1 0 0-4.09H24.662l6.918-9.835a1.881 1.881 0 0 0-3.08-2.16l-5.866 8.338L7.736 34.131l-.064-.085A16.852 16.852 0 0 1 3.808 24.8C3.421 19.676 5.74 13.665 9.716 9.485a17.49 17.49 0 0 1 13.252-5.722A17.268 17.268 0 0 1 35.352 9.54a22.029 22.029 0 0 1 5.859 15.295 16.239 16.239 0 0 1-2.111 7.011l-4.72 6.948a1.884 1.884 0 0 0 3.12 2.111"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1512",
    d: "M33.051 45.802a1.942 1.942 0 1 0-1.945-1.942 1.943 1.943 0 0 0 1.945 1.942"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1513",
    d: "M22.499 12.461a10.348 10.348 0 1 0 10.363 10.348 10.367 10.367 0 0 0-10.363-10.348m0 16.936a6.589 6.589 0 1 1 6.6-6.589 6.6 6.6 0 0 1-6.6 6.589"
  }))));
};

export default SvgLocation;